import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import logo from './../img/ABLogo_anim.gif';


const useStyles = makeStyles({
    loading: {
        cursor: 'wait',
        width: '100%',
        height: '100%',
        zIndex: '10000',
        position: 'absolute',
        left: 0,
        right: 0,
        background: `url(${logo}) 50% 50% no-repeat rgba(255, 255, 255, 0.8)`,
        opacity: '0.5',
        filter: `alpha(opacity=50)`
    },
});

/**
 * !!! Parent musi miec display: relative
 * @returns {*}
 * @constructorAn error occurred
 */
export default function AjaxLoading() {
    const classes = useStyles()
    return (
        <div className={classes.loading}/>
    )
}